<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="travel-map-page" data-cy="travel-map-page">
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">Travel Map</h1>
        </header>
        <TravelMapView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import GlobalFooter from "../GlobalFooter.vue";
import TravelMapView from "./TravelMapView.vue";
import type { RoleGroup } from "@/shared/access/RoleGroups";
import { ref } from "vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { UserRoles } from "@/Domain/UserRoles";

const roleGroups = [
  {
    roles: [
      ...UserRoles.ROLES_ALL_RC,
      UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
      UserRoles.ROLE_MIS,
      UserRoles.ROLE_ACCOUNTING,
      UserRoles.ROLE_RFR_SENIOR,
    ],
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>
